export default "__VITE_ASSET__2b395db7__"